const entries = []

const files = []

const current_trafx_data = {}

const isLoading = false

export default {
    files,
    entries,
    current_trafx_data,
    isLoading,
}